import React, { Component } from 'react';
import { withTranslation } from 'react-i18next';
import { compose } from 'redux';


import './style.scss'

class CardAnimation extends Component {
  constructor(props) {
    super(props);
    this.state = {}
  }

  render() {
    const { title, description, background, action } = this.props;

    return (
      <div className="card-animation cursor-pointer">
          <div className="card" onClick={action}>
            <img src={background} className="card__image" alt="" />
            <div className="card__overlay">
              <div className="card__header">
                <svg className="card__arc" xmlns="http://www.w3.org/2000/svg"><path /></svg>                     
                <div className="card__header-text">
                  <h3 className="card__title">{title}</h3>
                </div>
              </div>
              <p className="card__description">{description}</p>
            </div>
          </div>
      </div>
    );
  }
}


export default compose(
  withTranslation(),
)(CardAnimation);
